import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import CommonI18TableRow from './CommonI18TableRow';
import SecondaryLanguageText from 'dash-front/common-i18-dashboard-page/components/SecondaryLanguageText';
import { Table, TableHeader, TableBody, TableHeaderColumn, TableRow } from 'material-ui/Table';
import CircularProgress from 'material-ui/CircularProgress';
import { grey50 } from 'material-ui/styles/colors';

const Loader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 200px);
`;

const tableHeaderStyle = {
    backgroundColor: grey50,
    textTransform: 'capitalize',
};

const tableRowColumnTitleStyle = {
    width: 220,
};

function CommonI18Table({ LANGUAGES, defaultLanguage, tableRowList, isFinished = false }) {
    if (!isFinished) {
        return (
            <Loader>
                <CircularProgress size={80} thickness={5} />
            </Loader>
        );
    }

    return (
        <Table selectable={false} hoverable={false}>
            <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
                enableSelectAll={false}
                style={tableHeaderStyle}
            >
                <TableRow>
                    <TableHeaderColumn style={tableRowColumnTitleStyle}>Key</TableHeaderColumn>
                    <TableHeaderColumn>Dev example</TableHeaderColumn>
                    <TableHeaderColumn>{LANGUAGES[defaultLanguage]}</TableHeaderColumn>
                    <TableHeaderColumn>
                        <SecondaryLanguageText />
                    </TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false} showRowHover={false} deselectOnClickaway={false}>
                {tableRowList.map(id => <CommonI18TableRow key={id} id={id} />)}
            </TableBody>
        </Table>
    );
}

CommonI18Table.propTypes = {
    // From connect
    LANGUAGES: PropTypes.object.isRequired,
    defaultLanguage: PropTypes.string.isRequired,
    tableRowList: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    isFinished: PropTypes.bool,
};

export default connect(
    (
        { commonI18Dashboard: { LANGUAGES, defaultLanguage, statsList = [] }, requery = { queries: {} } },
        { isFinished = false },
    ) => ({
        LANGUAGES,
        defaultLanguage,
        tableRowList: statsList,
        isFinished: isFinished || (requery.queries['GET:i18'] && requery.queries['GET:i18'].isFinished),
    }),
)(CommonI18Table);



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/components/CommonI18Table.js
 **/